module.exports = __webpack_public_path__ + "static/media/art-egyptien.c7bd413b.jpg";